export default __webpack_public_path__ + "media/images/tenant/timeline/number_2-9801f5bfb8806f1f3a6bb0750deb78c0.svg";